import { Form, Formik } from "formik";
import Select from "react-select";
import {
  APPLY_BUTTON_STYLE,
  FILTER_SELECT_STYLES,
  RESET_BUTTON_STYLE,
  VEHICLE_TYPE_OPTIONS,
} from "./reportCommon";
import { DEFAULT_PRIMARY_VEHICLE_FILTERS } from "./staticReportData";

const toWardOption = (ward) => ({
  value: String(ward.circleId ?? ward.wardId ?? ""),
  label: ward.circleName ?? ward.wardName ?? ward.wardNo ?? "",
});

const PrimaryVehicleDeployFilter = ({
  initialValues = DEFAULT_PRIMARY_VEHICLE_FILTERS,
  wardOptions = [],
  onSearch,
  onReset,
}) => (
  <Formik
    initialValues={initialValues}
    enableReinitialize
    onSubmit={(values) => onSearch?.(values)}
  >
    {({ values, setFieldValue, resetForm, handleSubmit }) => {
      const wardSelectOptions = wardOptions.map(toWardOption);

      return (
      <Form onSubmit={handleSubmit}>
        <div className="row align-items-end">
          <div className="col-md-3 mb-3">
            <label className="form-label">Ward</label>
            <Select
              inputId="wardId"
              name="wardId"
              classNamePrefix="react-select"
              options={wardSelectOptions}
              value={
                wardSelectOptions.find(
                  (option) => option.value === String(values.wardId)
                ) || null
              }
              onChange={(selected) =>
                setFieldValue("wardId", selected ? selected.value : "")
              }
              placeholder="Select Ward"
              isClearable={false}
              menuPlacement="auto"
              menuPortalTarget={document.body}
              styles={FILTER_SELECT_STYLES}
            />
          </div>

          {/* <div className="col-md-3 mb-3">
            <label className="form-label">Vehicle Type</label>
            <select
              name="vehicleType"
              value={values.vehicleType}
              onChange={(event) =>
                setFieldValue("vehicleType", event.target.value)
              }
              className="form-select bg-white"
            >
              {VEHICLE_TYPE_OPTIONS.map((option) => (
                <option key={option.value || "all"} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div> */}

          <div className="col-md-3 mb-3">
            <label className="form-label">From Date</label>
            <input
              type="date"
              name="fromDateTime"
              value={values.fromDateTime}
              onChange={(event) =>
                setFieldValue("fromDateTime", event.target.value)
              }
              className="form-control bg-white"
            />
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">To Date</label>
            <input
              type="date"
              name="toDateTime"
              value={values.toDateTime}
              min={values.fromDateTime || undefined}
              onChange={(event) =>
                setFieldValue("toDateTime", event.target.value)
              }
              className="form-control bg-white"
            />
          </div>

          <div className="col-md-3 mb-3 d-flex gap-2">
            <button type="submit" style={APPLY_BUTTON_STYLE}>
              APPLY FILTERS
            </button>
            <button
              type="button"
              style={RESET_BUTTON_STYLE}
              onClick={() => {
                resetForm({ values: DEFAULT_PRIMARY_VEHICLE_FILTERS });
                onReset?.();
              }}
            >
              RESET
            </button>
          </div>
        </div>
      </Form>
      );
    }}
  </Formik>
);

export default PrimaryVehicleDeployFilter;
